<template>
    <stage :content="content"/>
</template>

<script>
// @ is an alias to /src
import stageContent from '@/data/gruender.js'
import stage from '@/components/stage.vue'

export default {
  name: 'Gruender',
  components: {
    stage
  },
  data () {
    return {
      content: stageContent
    }
  }
}
</script>
